import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { ComponentType } from '@angular/cdk/portal';
import { Overlay } from '@angular/cdk/overlay';

export type DialogState = 'opened' | 'minimized' | 'closed';

@Injectable({
  providedIn: 'root',
})
export class msgAppAccessService {
  private dialogRef: MatDialogRef<any> | null = null;
  private state$$ = new BehaviorSubject<DialogState>('closed');
  
  public state$: Observable<DialogState> = this.state$$.asObservable();

  constructor(private dialog: MatDialog, private overlay: Overlay) {}

  public open<T>(component: ComponentType<T>, config?: any): void {
    if (this.state$$.getValue() !== 'closed') {
      if (this.state$$.getValue() === 'minimized') {
        this.restore();
      }
      return;
    }

    const newConfig = { 
      ...config, 
      hasBackdrop: false, 
      disableClose: true,
      scrollStrategy: this.overlay.scrollStrategies.noop()
    };
    this.dialogRef = this.dialog.open(component, newConfig);


    this.state$$.next('opened');

    this.dialogRef.afterClosed().subscribe(() => {
      document.body.classList.remove('cdk-global-scrollblock');
      this.state$$.next('closed');
      this.dialogRef = null;
    });
  }

  public minimize(): void {
    if (!this.dialogRef) return;
    
    const overlayPane = this.getOverlayPane();
    if (overlayPane) {
      overlayPane.style.display = 'none';
      this.state$$.next('minimized');
    }
  }

  public restore(): void {
    if (!this.dialogRef) return;
    
    const overlayPane = this.getOverlayPane();
    if (overlayPane) {
      overlayPane.style.display = 'flex';
      this.state$$.next('opened');
    }
  }

  private getOverlayPane(): HTMLElement | null {
    if (!this.dialogRef) return null;
    const dialogElement = document.getElementById(this.dialogRef.id);
    return dialogElement ? dialogElement.closest('.cdk-overlay-pane') as HTMLElement : null;
  }

  private getBackdropElement(overlayPane: HTMLElement): HTMLElement | null {
    const paneWrapper = overlayPane.parentElement;
    if (paneWrapper && paneWrapper.previousElementSibling?.classList.contains('cdk-overlay-backdrop')) {
      return paneWrapper.previousElementSibling as HTMLElement;
    }
    return null;
  }
}